import React, {
  Fragment,
  useState,
  MouseEvent,
  Dispatch,
  SetStateAction
} from 'react'

import { Popover, IconButton, Button, Typography } from '@mui/material'

import { useStyles } from './style'
import { chevronUpDown } from '../../images/chevronUpDown'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { apiCall, ApiConfig } from '../../config/api'
import { setShowSnackbar } from '../../redux/actions/otInboundAction'
import { StatusSnackbar } from '../../redux/reducers/otInboundReducer'

interface ContextMenuProps {
  setSorter?: Dispatch<SetStateAction<number>>
  page: number
  pageSize: number
  workId: number
  handleGetOt: () => void
}

export const ContextMenu: React.FC<ContextMenuProps> = ({
  workId,
  handleGetOt,
  page,
  pageSize
}) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { isPriority } = useSelector((state: RootState) => state.otInbound)

  const dispatch = useDispatch()

  const ShowSnackbar = (message: string, status: StatusSnackbar) => {
    dispatch(setShowSnackbar(true, message, status))
  }

  const moveTop = async (workOrderId: number) => {
    apiCall(
      'PUT',
      `${ApiConfig.InboundApi}/UpdatePriorityTop?updateWorkOrderId=${workOrderId}&pageSize=${pageSize}`
    )
      .then(() => {
        handleClose()
        ShowSnackbar('Se priorizo correctamente', 'success')
        handleGetOt()
      })
      .catch(({ data: { message } }) => {
        handleClose()
        message
          ? ShowSnackbar(message, 'error')
          : ShowSnackbar('Error al priorizar', 'error')
        handleGetOt()
      })
  }

  const moveUp = async (workOrderId: number, page: number) => {
    apiCall(
      'PUT',
      `${
        ApiConfig.InboundApi
      }/UpdatePriorityUp?updateWorkOrderId=${workOrderId}&pageIndex=${
        page - 1
      }&pageSize=${pageSize}`
    )
      .then(() => {
        handleClose()
        ShowSnackbar('Se priorizo correctamente', 'success')
        handleGetOt()
      })
      .catch(({ data: { message } }) => {
        handleClose()
        message
          ? ShowSnackbar(message, 'error')
          : ShowSnackbar('Error al priorizar', 'error')
        handleGetOt()
      })
  }
  const moveDown = async (workOrderId: number, page: number) => {
    apiCall(
      'PUT',
      `${
        ApiConfig.InboundApi
      }/UpdatePriorityDown?updateWorkOrderId=${workOrderId}&pageIndex=${
        page - 1
      }&pageSize=${pageSize}`
    )
      .then(() => {
        handleClose()
        ShowSnackbar('Se priorizo correctamente', 'success')
        handleGetOt()
      })
      .catch(({ data: { message } }) => {
        handleClose()
        message
          ? ShowSnackbar(message, 'error')
          : ShowSnackbar('Error al priorizar', 'error')
        handleGetOt()
      })
  }

  return (
    <Fragment>
      <IconButton
        disabled={!isPriority}
        edge='end'
        aria-label='account of current user'
        aria-haspopup='true'
        color='inherit'
        onClick={handleClick}
        style={{ marginRight: '-92px' }}
      >
        <img
          src={chevronUpDown}
          alt='chevronUpDown'
          style={{
            width: '16px',
            height: '16px',
            maxWidth: '16px',
            minWidth: '16px',
            marginTop: '4px'
          }}
        />
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <div className={classes.container}>
          <Button
            color='primary'
            onClick={() => {
              moveTop(workId)
            }}
            className={classes.button}
            fullWidth
          >
            <Typography
              variant='overline'
              display='block'
              className={classes.text}
            >
              Mover al principio
            </Typography>
          </Button>
          <Button
            color='primary'
            onClick={() => moveUp(workId, page)}
            className={classes.button}
            fullWidth
          >
            <Typography
              variant='overline'
              display='block'
              className={classes.text}
            >
              Mover arriba
            </Typography>
          </Button>
          <Button
            color='primary'
            onClick={() => moveDown(workId, page)}
            className={classes.button}
            fullWidth
          >
            <Typography
              variant='overline'
              display='block'
              className={classes.text}
            >
              Mover abajo
            </Typography>
          </Button>
        </div>
      </Popover>
    </Fragment>
  )
}
